import './App.scss'
import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import LoginScreen from 'Screens/AuthScreens'
import Routes from 'Components/Routes'
import ProtectedRoute from 'Components/ProtectedRoute'
import MyErrorBoundary from 'Components/MyErrorBoundary'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { getLocalAuthToken, getLoginOtpFlowVersion } from 'Utils/LocalStorageHandler'

function App() {
  const history = useHistory()

  useEffect(() => {
    const unlisten = history.listen(() => {
      const CURRENT_LOGIN_FLOW_VERSION = 'otp-v1'
      const storedVersion = getLoginOtpFlowVersion()
      const accessToken = getLocalAuthToken()

      if (accessToken && storedVersion !== CURRENT_LOGIN_FLOW_VERSION) {
        localStorage.clear()

        history.push({
          pathname: ROUTE_STRINGS.login
        })
      }
    })

    return () => unlisten()
  }, [history])

  return (
    <MyErrorBoundary>
      <Switch>
        <Route exact path={ROUTE_STRINGS.login} component={LoginScreen} />
        <ProtectedRoute path={ROUTE_STRINGS.dashboard} component={Routes} />
      </Switch>
    </MyErrorBoundary>
  )
}

export default App
